import React from 'react';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import moment from 'moment';

const DOC_LABELS = { estimate: 'estimate', invoice: 'invoice', 'flat-invoice': 'flat invoice' };

// "Approved 03/14" beside a service, part or subcontracted line.
//
// approvedAt is stamped server-side when a customer signs a document that
// carried this line (functions/integrations/service/documentSends.js), so it is
// the date the customer approved the work — not a shop status, and not the same
// thing as a part's `approved` purchasing status. First approval wins, so this
// date never moves once set.
export default function ApprovedChip({ line, sx = {} }) {
  if (!line || !line.approvedAt) return null;

  const at = moment(line.approvedAt, 'YYYY/MM/DD');
  const shortDate = at.isValid() ? at.format('MM/DD') : line.approvedAt;
  const longDate = at.isValid() ? at.format('MM/DD/YYYY') : line.approvedAt;
  const doc = DOC_LABELS[line.approvedDocumentType] || 'estimate';

  return (
    <Tooltip title={`Approved by the customer on the ${doc} signed ${longDate}`}>
      <Chip
        label={`Approved ${shortDate}`}
        size="small"
        variant="outlined"
        sx={{ height: 18, fontSize: '0.65rem', color: 'success.dark', borderColor: 'success.main', ...sx }}
      />
    </Tooltip>
  );
}
